import React from "react"
import { ChartStatusFilter } from "../../../services/medicationmanagement/patientApi/models/ChartStatusFilter";
import {RadioButtonGroup} from '../../common/radio-button-group';

const ChartStatusOptions = [{
    code:ChartStatusFilter.All,
    desc:'Show all charts'
},
{
    desc:'Only show charts with changes, new admissions or allergy updates',
    code:ChartStatusFilter.WithChanges
}
];

export const ChartStatusFilterComponent = (props:{
    onChange:(val:ChartStatusFilter)=>void;
    value?: ChartStatusFilter
})=>{
    return <RadioButtonGroup 
        controlLabel="Chart Status" 
        nameField="desc" 
        valueField="code"
        options={ChartStatusOptions}
        value={props.value || ChartStatusFilter.All}
        onChange={props.onChange}
        />
}